import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: HttpClient) { }
  apiEndpoint: string = environment.apiUrl;
  apiVersion = 'v1';

  private handleError(error: any) {
    console.error('HTTP Error:', error);
    return throwError(() => error);
  }

  private createHeaders(customHeaders?: HttpHeaders, body?: any): HttpHeaders {
    let headers = new HttpHeaders();
    if (!(body instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json');
    }
    if (customHeaders) {
      customHeaders.keys().forEach((key) => {
        headers = headers.set(key, customHeaders.get(key)!);
      });
    }
    return headers;
  }

  get<T>(url: string, options?: { params?: HttpParams, headers?: HttpHeaders }): Observable<T> {
    const httpOptions = {
      headers: this.createHeaders(options?.headers),
      params: options?.params
    };

    return this.http.get<T>(`${this.apiEndpoint}/${url}`, httpOptions).pipe(catchError(this.handleError));
  }

  post<T>(url: string, body?: any, options?: { params?: HttpParams, headers?: HttpHeaders }): Observable<T> {
    const httpOptions = {
      headers: this.createHeaders(options?.headers, body),
      params: options?.params
    };
    return this.http.post<T>(`${this.apiEndpoint}/${url}`, body, httpOptions).pipe(catchError(this.handleError));
  }

  put<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    const options = {
      headers: this.createHeaders(headers)
    };
    return this.http.put<T>(`${this.apiEndpoint}/${url}`, body, options).pipe(catchError(this.handleError));
  }

  delete<T>(url: string, options?: { headers?: HttpHeaders, params?: any }): Observable<T> {
    const httpOptions = {
      headers: this.createHeaders(options?.headers),
      params: options?.params
    };
    return this.http.delete<T>(`${this.apiEndpoint}/${url}`, httpOptions).pipe(catchError(this.handleError));
  }

  patch<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    const options = {
      headers: this.createHeaders(headers)
    };
    return this.http.patch<T>(`${this.apiEndpoint}/${url}`, body, options).pipe(catchError(this.handleError));
  }


  downloadFile(url: string, body?: any) {
    const options: any = {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    };

    if (body) {
      return this.http.post(`${this.apiEndpoint}/${url}`, body, options);
    }

    return this.http.get(`${this.apiEndpoint}/${url}`, options);
  }
}
